<template>
    <div ref="documentsListContainer" class="container mb-5">

        <div class="k-tabs">
            <div class="k-tabs__sorting">
                <span class="k-tabs__sorting-text">Filtrovat podle:</span>

                <select @change="filterChanged" v-model="filterBy" ref="filterSelect1" class="form-control">
                    <option disabled value="" placeholder>Vyberte</option>
                    <option value="information_type">Typu informace</option>
                    <option value="category">Kategorie</option>
                    <option value="subcategory">Podkategorie</option>
                </select>


                <span class="k-custom-width" v-show="filterBy.length > 0">
                    <select @change="filterSelected" v-model="filterByOption" ref="filterSelect2" class="form-control">
                        <option disabled value="" placeholder>Vyberte</option>
                    </select>
                </span>

                <a v-if="is_remove_filters_btn_visible" @click="resetFilters" href="javascript:;" class="k-action k-action--control-danger">
                    Zrušit
                </a>

            </div>

            <div class="k-tabs__sorting">
                <span class="k-tabs__sorting-text">Řadit podle:</span>

                <select @change="sortChanged" v-model="orderBy" ref="sortSelect1" class="form-control">
                    <option value="date">Data vložení</option>
                    <option value="downloads">Počtu stažení</option>
                    <option value="size">Velikosti</option>
                </select>


                <select @change="sortChanged" v-model="orderDirection" ref="sortSelect2" class="form-control">
                    <option value="asc">Vzestupně</option>
                    <option value="desc">Sestupně</option>
                </select>
            </div>

        </div>

        <template v-if="documents.data && documents.data.length > 0">
            <div class="k-table k-table--doc-all">
                <div class="k-table__header">
                    <div class="k-table__cell">
                        Název / Kategorie
                    </div>

                    <div class="k-table__cell--type">
                        Typ
                    </div>

                    <div class="k-table__cell k-table__cell--meta">
                        Autor
                    </div>

                    <div class="k-table__cell k-table__cell--meta">
                        Datum
                    </div>

                </div>

                <transition-group name="list-complete" tag="div">
                    <div v-for="document in documents.data" :key="document.id" class="k-table__row">

                        <div class="k-table__cell">
                            <div class="k-file-meta k-file-meta--compact k-mr-20">
                                <svg class="k-file-meta__icon" role="img" width="24" height="25">
                                    <use fill="currentColor" xlink:href="/images/spritesheet.svg#file-pdf"/>
                                </svg>

                                <div class="k-file-meta__text">
                                    {{ document.size_formatted }}
                                </div>
                            </div>

                            <div class="mr-auto" >
                                <a  :href="document.detail_url" class="mb-1 d-block">
                                    <strong class="k-strong">
                                        {{ document.title }}
                                    </strong>
                                </a>

                                <div class="k-table__cell-meta ml-0">
                                    <a v-for="(url, title) in document.categories" class="k-link mr-2" :href="url">{{ title }}</a>
                                </div>
                            </div>

                        </div>

                        <div class="k-table__cell k-table__cell--type">
                            <div class="k-table__cell-meta">
                                {{ document.information_type }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--meta">
                            <div class="k-table__cell-meta">
                                {{ document.user_name }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--meta">
                            <div class="k-table__cell-meta">
                                {{ document.created_at }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--action k-border-left">
                            <a :href="document.detail_url" class="k-action k-action--control">
                                <svg class="k-action__icon" role="img" width="15" height="15">
                                    <use fill="currentColor" xlink:href="/images/spritesheet.svg#eye"/>
                                </svg>
                                Zobrazit
                            </a>
                        </div>
                    </div>

                </transition-group>
            </div>

            <pagination class="mt-5" :data="documents" @pagination-change-page="paginate" :limit="2"></pagination>
        </template>
        <template v-else>
            <div v-if="documents.data && documents.data.length === 0" class="k-table">
                <div class="k-table__row">
                    <div class="k-table__cell p-2 justify-content-center">
                        Nebyly nalezeny žádné dokumenty.
                    </div>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import Choices from 'choices.js';
    import Pagination from 'laravel-vue-pagination';

    export default {

        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            },
            categories: {
                type: Object,
                required: true
            },
            subcategories: {
                type: Object,
                required: true
            },
            informationTypes: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            documents: {},
            orderBy: 'date',
            orderDirection: 'desc',
            filterBy: '',
            filterChoicesInstance: null,
            filterByOption: '',
            filterByChoicesInstance: null,
            search: ''
        }),

        computed: {
            is_remove_filters_btn_visible: function() {
              return this.filterByOption.length > 0;
            },
            createDocumentLink: function() {
                return Links.createDocument;
            },
            filterOptions: function() {
                let options = [{value: '', label: 'Vyberte', disabled: true, selected: true}];
                if (this.filterBy === 'information_type') {
                    for (const key of Object.keys(this.informationTypes)) {
                        options.push({
                            value: key, label: this.informationTypes[key]
                        });
                    }
                }
                else if (this.filterBy === 'category') {
                    for (const key of Object.keys(this.categories)) {
                        options.push({
                            value: key, label: this.categories[key]
                        });
                    }
                }
                else if (this.filterBy === 'subcategory') {
                    for (const key of Object.keys(this.subcategories)) {
                        options.push({
                            value: key, label: this.subcategories[key]
                        });
                    }
                }
                return options;
            }
        },

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            orderBy: this.orderBy,
                            orderDirection: this.orderDirection,
                            filterBy: this.filterBy,
                            filterByOption: this.filterByOption,
                            search: this.search
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.documents = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Paginate results
             *
             * @param page
             * @returns void
             */
            paginate: async function(page = 1) {
                await this.getData(page);
                if (this.$refs.documentsListContainer) {
                    setTimeout( () => {
                        this.$scrollTo(this.$refs.documentsListContainer, 500, {offset: -80});
                    }, 300);
                }
            },

            /**
             * Sort changed event handler
             *
             * @returns void
             */
            sortChanged() {
                this.getData();
            },

            /**
             * Filter changed event handler
             *
             * @returns void
             */
            filterChanged() {
                this.filterByChoicesInstance.setChoices(this.filterOptions, 'value', 'label', true);
                this.filterByOption = '';
                if (this.filterBy.length === 0) {
                    this.getData();
                }
            },

            /**
             * Filter selected event handler
             *
             * @returns void
             */
            filterSelected() {
                this.getData();
            },

            /**
             * Reset filters
             *
             * @return void
             */
            resetFilters() {
                this.filterBy = '';
                this.filterByOption = '';
                this.filterChoicesInstance.setChoiceByValue('');
                this.getData();
            },

            initChoices(element) {
                return new Choices(element, {
                    shouldSortItems: false,
                    shouldSort: false,
                    classNames: {
                        containerOuter: 'choices k-sort-select-choices k-sort-select-choices--subcategories',
                        containerInner: 'choices__inner',
                        input: 'choices__input',
                        inputCloned: 'choices__input--cloned',
                        list: 'choices__list',
                        listItems: 'choices__list--multiple',
                        listSingle: 'choices__list--single',
                        listDropdown: 'choices__list--dropdown',
                        item: 'choices__item',
                        itemSelectable: 'choices__item--selectable',
                        itemDisabled: 'choices__item--disabled',
                        itemChoice: 'choices__item--choice',
                        placeholder: 'choices__placeholder',
                        group: 'choices__group',
                        groupHeading: 'choices__heading',
                        button: 'choices__button',
                        activeState: 'is-active',
                        focusState: 'is-focused',
                        openState: 'is-open',
                        disabledState: 'is-disabled',
                        highlightedState: 'is-highlighted',
                        hiddenState: 'is-hidden',
                        flippedState: 'is-flipped',
                        loadingState: 'is-loading',
                        noResults: 'has-no-results',
                        noChoices: 'has-no-choices'
                    }
                });
            }
        },

        created() {
            // listen for search input event
            window.events.$on('searchInputSubmitted', (search) => {
                this.search = search;
                this.paginate(1);
            });
        },

        mounted() {
            // get table data
            this.getData();

            // register choices
            let selects = [
                this.$refs.sortSelect1,
                this.$refs.sortSelect2,
            ];

            for (let sort of selects) {
                this.initChoices(sort);
            }

            this.filterChoicesInstance = this.initChoices(this.$refs.filterSelect1);
            this.filterByChoicesInstance = this.initChoices(this.$refs.filterSelect2);
        }
    }
</script>

<style >

    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity .5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }

    .k-custom-width .k-sort-select-choices {
        min-width: 170px !important;
    }

</style>
